export enum ResourceType {
  Aggregation = 'aggregation',
  Auth = 'auth',
  Company = 'company',
  CompanyTag = 'company-tag',
  Investor = 'investor',
  Deal = 'deal',
}
